import React from "react";

const PricingModal = ({ show, onClose, content }) => {
    if (!show) return null;

    return (
        <div className="pricing-modal-overlay">
            <div className="pricing-modal">
                <button className="pricing-modal-close" onClick={onClose}>
                    &times;
                </button>
                <div className="pricing-modal-content">
                    {content}
                </div>
            </div>
        </div>
    );
};

export default PricingModal;
